<script>
import {Column} from 'vxe-table'
export default {
  name: 'DataGridColumn',
  extends: Column
}
</script>
